import stringify from 'json-stable-stringify';

export const createRequestHash = async (request?: any): Promise<string | null> => {
  const normalizedBody = normalizeBody(request?.body);

  if (normalizedBody == null) {
    console.log('HTTP request hashing - unsupported body type: ', typeof request?.body);
    return null;
  }

  const normalizedRequest = {
    method: request?.method || 'GET',
    body: normalizedBody,
  };

  const dataToHash = stringify(normalizedRequest);
  const encoder = new TextEncoder();
  const dataBuffer = encoder.encode(dataToHash);
  const hashBuffer = await crypto.subtle.digest('SHA-256', dataBuffer);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map(byte => byte.toString(16).padStart(2, '0')).join('');
  return hashHex;
}

const normalizeBody = (body?: any): string | null => {
  if (!body) return '';

  if (typeof body === 'string') return body;

  if (typeof body === 'number') return body.toString();

  if (typeof body === 'object') return stringify(body) ?? null;

  return null;
}